import Inputmask from 'inputmask';
import CellInput from '../NCellInput/CellInput';

export default class CellInputMask extends CellInput {
	constructor($cell, options) {
		super($cell, options);
		this.mask;
		this.maskActionType();
	}

	maskActionType() {
		switch (this.inputType) {
			case 'phone':
				this.mask = new Inputmask('+7 (999) 999-99-99', { showMaskOnHover: false }).mask(this.$input);
				break;
			case 'code':
				this.mask = new Inputmask('999 999', { showMaskOnHover: false }).mask(this.$input);
				break;
			case 'passport':
				this.mask = new Inputmask('9999 999999', { showMaskOnHover: false }).mask(this.$input);
				break;
			case 'percent':
				this.mask = new Inputmask('9{1,3}', { showMaskOnHover: false }).mask(this.$input);
				break;
			case 'snils':
				this.mask = new Inputmask('999-999-999 99', { showMaskOnHover: false }).mask(this.$input);
				break;
			case 'divivsion-code':
				this.mask = new Inputmask('999-999', { showMaskOnHover: false }).mask(this.$input);
				break;
			//Серия паспорта
			case 'four-numbers':
				this.mask = new Inputmask('9', { showMaskOnHover: false, repeat: 4 }).mask(this.$input);
				break;
			//Номер паспорта
			case 'six-numbers':
				this.mask = new Inputmask('9', { showMaskOnHover: false, repeat: 6 }).mask(this.$input);
				break;
			//БИК
			case 'nine-numbers':
				this.mask = new Inputmask('9', { showMaskOnHover: false, repeat: 9 }).mask(this.$input);
				break;
			//ИНН
			case 'ten-numbers':
				this.mask = new Inputmask('9', { showMaskOnHover: false, repeat: 12 }).mask(this.$input);
				break;
			//Счет и корсчет
			case 'twenty-numbers':
				this.mask = new Inputmask('9', { showMaskOnHover: false, repeat: 20 }).mask(this.$input);
				break;
			case 'sum': {
				const options = {
					showMaskOnHover: false,
					groupSeparator: ' ',
					rightAlign: false,
					digits: 2,
					suffix: ' ₽',
				};

				this.mask = new Inputmask('currency', options).mask(this.$input);
				break;
			}
			case 'fio': {
				this.mask = new Inputmask('*{2,20}', {
					showMaskOnHover: false,
					definitions: {
						'*': {
							validator: "[А-Яа-яЁёVI .,'`-]",
						},
						V: {
							validator: 'V',
						},
						I: {
							validator: 'I',
						},
					},
					clearMaskOnLostFocus: true,
				}).mask(this.$input);
				break;
			}
			// case 'sumPay':
			//     this.mask = new Inputmask('9{1,20}[.9{1,2}]', { showMaskOnHover: false, greedy: false }).mask(this.$input);
			//     break;

			default:
				console.error(this.inputType, 'Не нашел тип маски в data-input-type');
		}
	}

	isInputChanged() {
		return !(this.startValue === this.mask.unmaskedvalue());
	}

	//Общие для всех элементов форм методы
	isInputError(showError = false) {
		const isError = this.isRequired ? this.checkValidField() : this.isRequired;

		if (showError && isError && this.isRequired) {
			this.errorStatus();
		}

		return isError;
	}

	checkValidField() {
		switch (this.inputType) {
			case 'fio':
				return this.isValidFIO();
			default:
				return !this.mask.isComplete();
		}
	}

	normalizeValue() {
		this.currentValue = this.currentValue.trim();
	}

	//Валидация ФИО
	isValidFIO() {
		const forbiddenCharacters = ['.', '-', "'", ' ', ','];
		const errorMessage = 'Недопустимый символ или комбинация символов в Фамилии, Имени или Отчестве.';
		const value = this.$input.value.trim();
		const firstSymbolIncludes = forbiddenCharacters.includes(value[0]);
		const lastSymbolIncludes = forbiddenCharacters.includes(value[value.length - 1]);
		const hasDoubleSymbols = /([.,-])\1/.exec(value) ?? [];
		const separateURL = window.location.href.split('/');
		const lastEndPoint = separateURL[separateURL.length - 1];
		let searchFor = "promo10";

		if (!this.mask.isComplete()) {
			if(lastEndPoint.includes(searchFor)) {
				this.$errorMessage.innerHTML = 'Заполните поле';
				return true;
			} else {
				this.$errorMessage.innerHTML = 'Заполните поле';
				return true;
			}
		}
		if (firstSymbolIncludes) {
			this.$errorMessage.innerHTML = errorMessage;
			return true;
		}
		if (lastSymbolIncludes) {
			this.$errorMessage.innerHTML = errorMessage;
			return true;
		}
		if (value[0] === ')' || value[value.length - 1] === '(') {
			this.$errorMessage.innerHTML = errorMessage;
			return true;
		}
		if (hasDoubleSymbols.length === 2) {
			this.$errorMessage.innerHTML = errorMessage;
			return true;
		}
		if (/[.\' ,-]{2,}/.test(value) && /^(\S{2,}|-{2,}|,{2,}|(\S{2,}|)){2,}$/.test(value)) {
			this.$errorMessage.innerHTML = errorMessage;
			return true;
		}
		if (/\([^\)]+(\(|$)/.test(value) || /\)[^\)]+(\)|$)/.test(value)) {
			this.$errorMessage.innerHTML = errorMessage;
			return true;
		}

		return false;
	}
}
